import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HUB_API_SETTINGS_TOKEN } from '../../hub-api-settings-token';
import { HubApiSettingsService } from '../../hub-api-settings.service';
import { PayrollReportInput } from '../model/query/payroll-report-input';
import { IndividualPayrollReportInput } from '../model/query/individual-payroll-report-input';
import { CumulativeReportInput } from '../model/query/cumulative-report-input';
import { Query } from '../model/query/query';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

// Generated service for communicating with the TimesheetReport API endpoint.
@Injectable()
export class TimesheetReportEndpointService {

  constructor(
    private http: HttpClient,
    private settingsService: HubApiSettingsService,
  ) {}

  CollectivePayrollExport(payrollReportInput: PayrollReportInput): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: payrollReportInput,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Timesheet/collective-payroll/export',
      options);
  }

  CollectivePayrollReport(payrollReportInput: PayrollReportInput): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: payrollReportInput,
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Timesheet/collective-payroll',
      options);
  }

  IndividualPayrollExport(payrollReportInput: IndividualPayrollReportInput): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: payrollReportInput,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Timesheet/individual-payroll/export',
      options);
  }

  IndividualPayrollReport(payrollReportInput: IndividualPayrollReportInput): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: payrollReportInput,
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Timesheet/individual-payroll',
      options);
  }

  CumulativeContractReport(payrollReportInput: CumulativeReportInput): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: payrollReportInput,
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Timesheet/cumulative-contract',
      options);
  }

  CumulativeContractExport(payrollReportInput: CumulativeReportInput): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: payrollReportInput,
      responseType: 'arraybuffer' as 'arraybuffer',
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'Reports/Timesheet/cumulative-contract/export',
      options);
  }
}
